interface BetaBadgeProps {
  label?: 'Preview' | 'Beta' | 'New'
  className?: string
}

/**
 * Reusable badge component for preview/beta/new feature indicators.
 * Uses the primary cyan style matching the App Permissions "Preview" badge.
 *
 * Usage:
 *   <BetaBadge />                       // Default "Preview" label
 *   <BetaBadge label="Beta" />          // "Beta" label
 *   <BetaBadge label="New" />           // "New" label for soft launch phase
 */
export default function BetaBadge({ label = 'Preview', className = '' }: BetaBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500/10 text-primary-400 border border-primary-500/30 ${className}`}
    >
      {label}
    </span>
  )
}
